export const CookieHelper = {
  get: (cookieName) => {
    // Separate cookies.
    const cookies = document.cookie.split('; ');
    // Find the cookie by its key.
    const cookie = cookies.find((row) => row.startsWith(`${cookieName}=`));
    // Get the cookie value.
    const [, cookieValue] = cookie != null ? cookie.split('=') : [cookieName, null];
    // Return the value.
    return cookieValue;
  },

  getUrl: (cookieName) => {
    const cookies = document.cookie.split('; ');

    for (const cookie of cookies) {
        const [name, ...valueParts] = cookie.split('=');
        if (name === cookieName) {
            const value = decodeURIComponent(valueParts.join('='));
            return value;
        }
    }

    return null;
  },

  remove: (cookieName) => {
    const host = window.location.hostname;
    document.cookie = `${cookieName}=;  path=/; domain=${host};  expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;

    try {
      if (host.startsWith('www')) {
        document.cookie = `${cookieName}=;  path=/; domain=${host.replace(
          'www',
          '',
        )};  expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
      }
    } catch (error) {
      // do nothing
    }
  },

  create: (cookieName, value) => {
    document.cookie = `${cookieName}=${value}`;
  },

  createWithExpiration: (cookieName, cookieValue, nHours) => {
    const today = new Date();
    const expire = new Date();
    if (nHours==null || nHours==0) nHours=2;
    expire.setTime(today.getTime() + 3600000*nHours);
    document.cookie = cookieName + "=" + cookieValue + "; path=/; expires=" + expire.toGMTString();
  }
};
